import { withCurrentParams } from 'actions/utils';
import { SCENE_CREATE } from 'store/eventConstants';
import { BROADCAST_SCENE_CREATE } from 'actions/Types';

/**
 * Create a scene action
 *
 * @param {Object} scenePayload
 */
export default scenePayload => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const action = {
        type: BROADCAST_SCENE_CREATE,
        request: async apiClient => {
          const payload = { ...scenePayload };
          const { scene } = await apiClient.broadcast.createScene(
            teamId,
            eventId,
            broadcastId,
            payload
          );

          const {
            meeting: { attendeeResponse }
          } = getState();
          // Any other subsequent action to be performed before response is reduced
          socket.emit(SCENE_CREATE, {
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });

          return { scene };
        }
      };
      dispatch(action);
    }
  );
};
